// import { ApiServiceProvider } from 'app/api-service';
import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import * as _ from 'lodash'
import { GridOptions } from '@ag-grid-community/all-modules'
import { ApiServiceProvider } from 'app/api-service'
@Injectable()
export class LevaSummaryService extends ApiServiceProvider {}
